import React, { useContext, useEffect, useRef } from "react";
import { useAuthStore } from "../@shared/store/useAuthStore";
import Dashboard from "./Dashboard";
import Landing from "../components/HomeScreen/Landing";
import { Grid } from "@mui/material";
import { MainContext } from "../App";
import TutorialSequences from "./TutorialSequences";
import { getDocs, collection, addDoc } from "firebase/firestore";
import { db } from "../@shared/firebase/config";

const HomeScreen = ({ isAuth }) => {
  const { navigate, gameScreenLoading, setGameScreenLoading } =
    useContext(MainContext);
  const { userData } = useAuthStore();

  const hasIssuedRewardsRef = useRef(false); // 🚨 Track execution

  const issueInitialSignupRewards = async (userId) => {
    try {
      //first fetch to see if the user has already been issued rewards
      const rewardsRef = collection(db, "users", userId, "rewards");

      const rewardsSnap = await getDocs(rewardsRef);
      const rewards = rewardsSnap.docs.map((doc) => doc.data());
      const hasRewards = rewards.length > 0;
      if (hasRewards) {
        console.log("✅ User has already been issued rewards.");
        return;
      }

      console.log("🎁 Issuing signup rewards for:", userId);
      // Fetch available character cards
      const charactersSnap = await getDocs(collection(db, "Character cards"));
      const characterCards = charactersSnap.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .map((card) => ({
          ...card,
          type: "character",
          _uuid: `${Date.now()}-${Math.random()}`,
        }))
        .filter(
          (card) =>
            card.name === "Zaporia" ||
            card.name === "Toshi" ||
            card.name === "Ashro"
        );

      // Fetch available infinity cards
      const infinitySnap = await getDocs(collection(db, "Infinity cards"));
      let infinityCards = infinitySnap.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
          _uuid: `${Date.now()}-${Math.random()}`,
        }))
        .filter((card) => card.finite !== "TRUE");

      // Defensive check
      if (characterCards.length === 0 || infinityCards.length < 40) {
        console.warn("⚠️ Not enough cards to issue signup rewards.");
        return;
      }

      // Shuffle helper
      const shuffleArray = (arr) => {
        const shuffled = [...arr];
        for (let i = shuffled.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
      };

      // 🎴 Shuffle and slice to 40 unique cards
      const shuffledInfinity = shuffleArray(infinityCards).slice(0, 40);

      // 🃏 Break into 4 card packs (10 each)
      const cardPacks = [];
      for (let i = 0; i < 4; i++) {
        const pack = shuffledInfinity.slice(i * 10, i * 10 + 10);
        cardPacks.push(pack);
      }

      // 1. Character card reward
      const getRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];
      await addDoc(rewardsRef, {
        type: "character card",
        issuedAt: Date.now(),
        claimed: false,
        reward: getRandom(characterCards),
        amount: 1,
      });

      // 2-5. Four card pack rewards
      for (let i = 0; i < 4; i++) {
        await addDoc(rewardsRef, {
          type: "card pack",
          issuedAt: Date.now(),
          claimed: false,
          reward: {
            pack: cardPacks[i],
          },
          amount: 1,
        });
      }

      // 6. Infinity tokens reward
      await addDoc(rewardsRef, {
        type: "infinity tokens",
        issuedAt: Date.now(),
        claimed: false,
        reward: { currency: "Infinity Tokens" },
        amount: 250,
      });

      console.log("✅ Signup rewards issued for user:", userId);
    } catch (e) {
      console.error("Error in issueInitialSignupRewards:", e);
    }
  };

  useEffect(() => {
    if (userData && !hasIssuedRewardsRef.current) {
      hasIssuedRewardsRef.current = true;

      issueInitialSignupRewards(userData.id);
    }
    if (gameScreenLoading && userData) {
      setTimeout(() => {
        setGameScreenLoading(false);
      }, 3500);
    }
  }, [userData, gameScreenLoading]);

  return (
    <Grid container xs={12} style={{ height: "100%" }}>
      {userData ? (
        !userData.completedTutorial ? (
          <>
            {/* Tutorial Sequnce Component */}
            <TutorialSequences />
          </>
        ) : (
          <>
            <Dashboard />
          </>
        )
      ) : (
        <>
          <Landing isAuth={isAuth} />
        </>
      )}
    </Grid>
  );
};

export default HomeScreen;
